export const NerdWalletBlackIcon = () => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 0.34669C0 0.163444 0.148551 0.0148926 0.331797 0.0148926H5.19816C5.31211 0.0148926 5.41265 0.0723376 5.47238 0.159849L10.6912 5.3612V0.34669C10.6912 0.163444 10.8398 0.0148926 11.023 0.0148926H15.6682C15.8514 0.0148926 16 0.163443 16 0.34669V15.6831C16 15.8663 15.8514 16.0149 15.6682 16.0149H10.8018C10.6879 16.0149 10.5873 15.9574 10.5276 15.8699L5.30876 10.6676V15.6831C5.30876 15.8663 5.16021 16.0149 4.97696 16.0149H0.331797C0.148551 16.0149 0 15.8663 0 15.6831V0.34669Z"
        fill="black"
      />
    </svg>
  );
};
